<template>
  <div class="site-setting">
    <div class="User__btn_container" v-if='settingPermission'>
      <!-- <md-button class="md-raised md-primary btn_customer add-bin-btn" v-if="!generalInfoEditing" @click="enableEditGeneralInfo"> <md-icon class="md-size-2x">create</md-icon>Edit setting</md-button> -->
      <md-button v-if="!generalInfoEditing" class="md-raised md-primary Setting_btn btn_edit"  @click="enableEditGeneralInfo"> 
        <svg style="margin-right:8px" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3256 1.82783L20.1521 0.654382C19.2796 -0.218127 17.7587 -0.218127 16.8862 0.654382L15.3685 2.17207C15.3674 2.17315 15.3653 2.17532 15.3642 2.1764C15.3631 2.17748 15.3609 2.17965 15.3598 2.18073L6.32407 11.2154C6.22447 11.315 6.16061 11.4438 6.14112 11.5824L5.5544 15.6895C5.52517 15.8919 5.59337 16.0954 5.73734 16.2405C5.85967 16.365 6.02529 16.4321 6.19633 16.4321C6.22664 16.4321 6.25803 16.4299 6.28834 16.4256L10.3954 15.8389C10.534 15.8194 10.6639 15.7544 10.7624 15.6559L19.7971 6.62013C19.7982 6.61905 19.8003 6.61689 19.8014 6.6158C19.8025 6.61472 19.8047 6.61256 19.8057 6.61147L21.3234 5.09379C21.7597 4.65753 22 4.07838 22 3.46135C22 2.84431 21.7608 2.26409 21.3256 1.82783ZM9.99813 14.5831L6.96275 15.0172L7.39684 11.9808L15.8242 3.55445L18.4255 6.15574L9.99813 14.5831ZM20.4065 4.17473L19.3435 5.23776L16.7422 2.63647L17.8052 1.57344C18.1874 1.19023 18.852 1.19023 19.2331 1.57344L20.4065 2.74689C20.5981 2.93741 20.7021 3.1918 20.7021 3.46135C20.7021 3.7309 20.5981 3.9842 20.4065 4.17473ZM20.7843 11.4525V16.8651C20.7843 19.6114 18.5511 21.8447 15.8048 21.8447H4.97958C2.23323 21.8447 0 19.6114 0 16.8651V6.03991C0 3.29356 2.23323 1.06033 4.97958 1.06033H10.3922C10.7516 1.06033 11.0417 1.35152 11.0417 1.70984C11.0417 2.06815 10.7505 2.35935 10.3922 2.35935H4.97958C2.94986 2.35935 1.29902 4.01019 1.29902 6.03991V16.8651C1.29902 18.8948 2.94986 20.5456 4.97958 20.5456H15.8048C17.8345 20.5456 19.4853 18.8948 19.4853 16.8651V11.4525C19.4853 11.0931 19.7765 10.803 20.1348 10.803C20.4931 10.803 20.7843 11.0931 20.7843 11.4525Z" fill="white"/>
        </svg>
        <strong>Edit Setting</strong>
      </md-button>
      <md-button class="md-raised Setting_btn" v-if="generalInfoEditing" style="height:48px;width:100px;border-radius: 4px;" @click="discard_active=true"><strong>Cancel</strong></md-button>
      <md-button class="md-raised md-primary Setting_btn" style="width:158px;height:48px;border-radius: 4px;" v-if="generalInfoEditing" @click="saveGeneralInfo"><strong>Save</strong></md-button>
    </div>
    <div class="general-info">
      <div class="setting_title">General info</div>
      <div class="info-fields">
        <div class="info-field">
          <label>Customer</label>
          <p >{{site.customer ? site.customer.name : 'Unassign'}}</p>
        </div>

        <div class="info-field">
          <label>Site</label>
          <p v-if="!generalInfoEditing">{{site.name}}</p>
          <input type="text" v-model="tempSiteName" v-else>
        </div>

        <div class="info-field">
          <label>PSM Request Expiry</label>
          <p v-if="!generalInfoEditing">{{site.psmExpire}}</p>
          <input type="number" v-model="tempPsmExpire" v-else>
        </div>

        <!-- <div class="info-field"  style=" visibility: hidden;">
          <label>System</label>
          <p>{{site.system ? site.system.name : ''}}</p>
        </div> -->

        <div class="info-field" >
          <label>Address</label>
          <p>{{site.customer ? site.customer.address : 'Unassign'}}</p>
        </div>

        <div class="info-field">
          <label>Phone</label>
          <p>{{site.customer ? site.customer.phone : 'Unassign'}}</p>
        </div>

        <!-- <div class="info-field" style=" visibility: hidden;" >
          <label>Email</label>
          <p>{{site.customer ? site.customer.email : 'Unassign'}}</p>
        </div> -->

        <!-- <div class="info-field" style=" visibility: hidden;">
          <label>Tax</label>
          <p>{{site.customer ? site.customer.tax : 'Unassign'}}</p>
        </div> -->

        <div class="info-field">
          <label>Website</label>
          <p>{{site.customer ? site.customer.website : 'Unassign'}}</p>
        </div>
        <div class="info-field">
          <label>Mode Operation</label>
          <p v-if="!generalInfoEditing"> {{site.mode ? "External Loan Workflow" : 'Internal Loan Workflow'}}</p>
          <select name="mode" id="mode" v-model="tempSiteMode" v-else>
            <option value="1">External Loan Workflow</option>
            <option value="0">Internal Loan Workflow</option>
          </select>
        </div>
        <div class="info-field">
          <label>API Key</label>
          <p v-if="!generalInfoEditing">{{site.apiKey ? site.apiKey : 'NA'}}</p>
          <input type="text" v-model="tempSiteApiKey" minlength="5" v-else>
        </div>
        <div class="info-field">
          <label>ROOT User</label>
          <p v-if="!generalInfoEditing"> {{site.activeR ? "Enable" : 'Disable'}}</p>
          <select name="mode" id="mode" v-model="tempActiveR" v-else>
            <option value="1">Enable</option>
            <option value="0">Disable</option>
          </select>
        </div>
      </div>
    </div>

    <div class="inventory-info">
      <div class="low-stock">
        <div class="setting_title" style="margin-bottom:16px">Mustering Report Schedule</div>
        <div class="info-fields">
          <!-- <div class="info-field">
            <label>Type Notification</label>
            <p v-if="!generalInfoEditing" ><span v-for="item in type_nofi" :key="item" style="margin-right:10px">{{item}}</span></p>
            <div class="checkbox-type" v-else>
              <md-checkbox :value="true" class="md-primary" v-model="tempLowStockSms">SMS</md-checkbox>
              <md-checkbox :value="true" class="md-primary" v-model="tempLowStockEmail">Email</md-checkbox>
            </div>
          </div> -->

          <div class="info-field">
            <label >Time Notification</label>
            <p v-if="!generalInfoEditing">{{tempInventoryReportSchedule}}</p>
            <div class="time-nofi-radios" v-else>
                <!-- <div style="display:flex;margin-bottom:16px">
                  <div style="display:flex;margin-right:48px;cursor:pointer;" >
                    <input type="radio"  value="weekly" id='nofi_weekly' v-model="type_inventory" >
                    <label style="margin-left:9px;" for="nofi_weekly">Weekly</label> 
                  </div>
                  <div style="display:flex;cursor:pointer;margin-right:48px">
                    <input  type="radio"  value="monthly" id="nofi_monthly" v-model="type_inventory" >
                    <label style="margin-left:9px;" for ="nofi_monthly">Monthly</label> 
                  </div> 
                  <div style="display:flex;cursor:pointer;">
                    <input  type="radio"  value="" id="nofi_none" v-model="type_inventory" >
                    <label style="margin-left:9px;" for ="nofi_none">None</label> 
                  </div> 
                </div>

                <div class="item_container" v-if="type_inventory==='weekly'">
                    <div class="item_select" v-for="(item,i) in list_day" :key="i">
                      <label :for="item+'nofi'" style="margin-bottom:8px">{{item}}</label>
                      <input :id="item+'nofi'" type="checkbox"   :value="(i+1)" v-model="inventory_choose_week" > 
                    </div>
                </div>
                <div class="item_container" v-else-if="type_inventory==='monthly'">
                    <div class="item_select"  v-for="(item,i) in list_date" :key="i">
                      <label :for="item+'nofi'" style="margin-bottom:8px">{{item}}</label>
                      <input :id="item+'nofi'" type="checkbox"   :value="item" v-model="inventory_choose_month" > 
                    </div>
                </div> -->
                <input type="time" v-model="time_inventory" />
            </div>
          </div>
          <hr />

          <div class="mail-now">
            <p style="color:#6D6E71">Generate and send mustering report via email now</p>
            <button @click="sendMusteringMailNow"><md-icon >mail_outline</md-icon> Perform Mustering</button>
          </div>
        </div>
      </div>

      <div class="inventory-report">
        <div class="setting_title">Reminder Report Schedule</div>
        <div class="info-fields">
          <div class="info-field">
            <label>Time Notification</label>
            <p v-if="!generalInfoEditing">{{tempOverDueSchedule}}</p>
            <div class="time-nofi-radios" v-else>
                <!-- <div style="display:flex;margin-bottom:16px">
                  <div style="display:flex;margin-right:48px;cursor:pointer;" >
                    <input type="radio"  value="weekly" id='report_weekly' v-model="type_overdue" >
                    <label style="margin-left:9px;" for="report_weekly">Weekly</label> 
                  </div>
                  <div style="display:flex;cursor:pointer;margin-right:48px">
                    <input  type="radio"  value="monthly" id="report_monthly" v-model="type_overdue" >
                    <label style="margin-left:9px;" for="report_monthly">Monthly</label> 
                  </div> 
                  <div style="display:flex;cursor:pointer;">
                    <input  type="radio"  value="" id="report_none" v-model="type_overdue" >
                    <label style="margin-left:9px;" for ="report_none">None</label> 
                  </div> 
                </div>

                <div class="item_container" v-if="type_overdue==='weekly'">
                    <div class="item_select" v-for="(item,i) in list_day" :key="i">
                      <label :for="item+'report'" style="margin-bottom:8px">{{item}}</label>
                      <input :id="item+'report'" type="checkbox"   :value="(i+1)" v-model="overdue_choose_week" > 
                    </div>
                </div>
                <div class="item_container" v-else-if="type_overdue==='monthly'">
                    <div class="item_select"  v-for="(item,i) in list_date" :key="i">
                      <label :for="item+'report'" style="margin-bottom:8px">{{item}}</label>
                      <input :id="item+'report'" type="checkbox"   :value="item"  v-model="overdue_choose_month"> 
                    </div>
                </div> -->
                <input type="time" v-model="time_overdue"/>
            </div>
            <!-- <label>Reminder Time (Hour)</label>
            <p v-if="!generalInfoEditing">{{reminder_time}}</p>
            <div v-else><input type="number" min=1 max=100 v-model="reminder_time" required/></div> -->
          </div>

          <hr />

          <div class="mail-now">
            <p style="color:#6D6E71">Generate and send reminder report via email now</p>
            <button @click="sendMailNow"><md-icon >mail_outline</md-icon> Send email</button>
          </div>
        </div>
      </div>
    </div>
    <div class="table_email_container">
      <div class="setting_title">Receiver Information</div>
      <label for="email_input">Receiver’s Email</label>
      <div class="form_container" v-if='generalInfoEditing'>
        <input type="text" placeholder="Email of Receiver " v-model="email" />
        <button :disabled='!generalInfoEditing' @click="onAddEmail">Add email</button>
      </div>
      <md-table v-model="list_email" md-card style="max-height:300px">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell  md-label="Email Receiver " >{{ item.email }}</md-table-cell>
          <md-table-cell  md-label="Created at" >{{ convertTime(item.created) }}</md-table-cell>
          <md-table-cell>
            <svg @click="onDeleteEmail(item)" v-if="generalInfoEditing" class="remove"  width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.40058 1H8.97953H15.9269H16.5058V1.57895V4.47368H22.1795H22.7585V5.63158H22.1795H16.5058H15.3479H9.55848H8.40058H2.7269H2.14795V4.47368H2.7269H8.40058V1.57895V1ZM9.55848 4.47368H15.3479V2.15789H9.55848V4.47368ZM5.39005 7.13684V6.55789H4.23216V7.13684V21.0316C4.23216 22.1187 5.1135 23 6.20058 23H18.7058C19.7929 23 20.6743 22.1187 20.6743 21.0316V7.13684V6.55789H19.5164V7.13684V21.0316C19.5164 21.4792 19.1534 21.8421 18.7058 21.8421H6.20058C5.75299 21.8421 5.39005 21.4792 5.39005 21.0316V7.13684ZM13.0322 10.2632V9.68421H11.8743V10.2632V17.9053V18.4842H13.0322V17.9053V10.2632ZM9.55848 9.68421V10.2632V17.9053V18.4842H8.40058V17.9053V10.2632V9.68421H9.55848ZM16.5058 10.2632V9.68421H15.3479V10.2632V17.9053V18.4842H16.5058V17.9053V10.2632Z" fill="#6D6E71"/>
            </svg>
          </md-table-cell>
          

          </md-table-row>
      </md-table>
    </div>
    <md-dialog :md-active.sync="discard_active" class="custom_dialog_container">
      <md-dialog-title >
        <label class='lb_close' @click="discard_active=false"><md-icon class="icon_close ">clear</md-icon></label>
        <label class='lb-title'>Discard Change</label>
      </md-dialog-title>
      <md-dialog-content>
          <span>Are you sure you want to discard unsaved changes?</span>
      </md-dialog-content>
      <md-dialog-actions >
          <md-button class="md-raised " @click="discard_active = false">Cancel</md-button>
          <md-button class="md-raised md-accent" @click="handleDiscard">Discard</md-button>
      </md-dialog-actions>
    </md-dialog>

    
    <md-snackbar :md-active.sync="showSnackbar" :md-duration="2000" md-position="center">Site settings saved successfully!</md-snackbar>
    <md-dialog :md-active.sync="send_active" :md-click-outside-to-close="auto" class="custom_dialog_container">
        <md-dialog-title >
          <label class='lb-title'>Sync Data</label>
        </md-dialog-title>
        <md-dialog-content>
          <center><md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner></center>
        </md-dialog-content>
      </md-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  created() {
    request('get', '/sites/' + this.id)
      .then(data => {
        this.site = data.site
        this.list_email=this.site.email?this.site.email:[]
        this.reminder_time = this.site.reminderTime
        if(this.site.inventoryReportSchedule&&this.site.inventoryReportSchedule!==''){
          let inventory_data = this.site.inventoryReportSchedule.split(';')
          this.time_inventory=inventory_data[0]
          if(this.site.typeInventory&&this.site.typeInventory==='weekly'){
            let days=inventory_data[1].split(',').map(el=>Number(el))
            let daysOfWeek= days.map(el=>this.list_day[el-1])
            this.tempInventoryReportSchedule='Weekly on every '+daysOfWeek.join(', ') +' at '+inventory_data[0] +' GMT+08:00'
            this.type_inventory='weekly'
            this.inventory_choose_week=days
          }
          // else if(this.site.typeInventory&&this.site.typeInventory==='monthly'){
          //   let days = inventory_data[1].split(',').map(el=>Number(el))
          //   this.tempInventoryReportSchedule='Monthly on every '+days.join(', ')+' at '+inventory_data[0] +' GMT+07:00'
          //   this.type_inventory='monthly'
          //   this.inventory_choose_month=days
          // }
          
        }
        if(this.site.overdueReportSchedule&&this.site.overdueReportSchedule!==''){
          let overdue_data = this.site.overdueReportSchedule.split(';')
          this.time_overdue=overdue_data[0]
          if(this.site.typeOverdue&&this.site.typeOverdue==='weekly'){
            let days=overdue_data[1].split(',').map(el=>Number(el))
            let daysOfWeek= days.map(el=>this.list_day[el-1])
            this.tempOverDueSchedule='Weekly on every '+daysOfWeek.join(', ') +' at '+overdue_data[0] +' GMT+08:00'
            this.type_overdue='weekly'
            this.overdue_choose_week=days
          }
          // else if(this.site.typeOverdue&&this.site.typeOverdue==='monthly'){
          //   let days = overdue_data[1].split(',').map(el=>Number(el))
          //   this.tempOverDueSchedule='Monthly on every '+days.join(', ')+' at '+overdue_data[0] +' GMT+07:00'
          //   this.type_overdue='monthly'
          //   this.overdue_choose_month=days
          // }
        }

      })
      .catch(err => console.log(err))
  },
  data() {
    return {
      id: this.$route.params.id,
      site: {
        customer: {},
        system: {}
      },
      send_active:false,
      auto:false,
      generalInfoEditing: false,
      tempSiteName: '',
      tempSiteApiKey:'',
      tempSiteMode:'0',
      tempActiveR:1,
      tempPsmExpire:0,
      tempOverDueSchedule: '',
      tempInventoryReportSchedule: '',
      showSnackbar: false,
      discard_active:false,
      type_inventory:'weekly',
      type_overdue:'weekly',
      time_inventory:'',
      time_overdue:'',
      reminder_time:12,
      list_day:["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
      // list_date:Array.from({length: 31}, (v, k) => k+1),
      list_email:[],
      email:'',
      inventory_choose_week:[1,2,3,4,5,6,7],
      // inventory_choose_month:[],
      overdue_choose_week:[1,2,3,4,5,6,7],
      
    }
  },
  computed:{
    settingPermission()
    {
      let accessRight=['ROOT','CUSTOMER','MASTER'];
      return (accessRight.includes(this.$store.state.role))
    }
  },

  methods: {
    handleCustomTime(){
      console.log("custom time")
    },
    handleDiscard(){
      console.log('discard')
      this.generalInfoEditing = false;
      this.discard_active=false;
      this.list_email=this.site.email?this.site.email:[]
      // this.reminder_time = this.site.reminderTime
      this.email=''
      if(this.site.inventoryReportSchedule&&this.site.inventoryReportSchedule!==''){
        let inventory_data = this.site.inventoryReportSchedule.split(';')
        this.time_inventory=inventory_data[0]
        if(this.site.typeInventory&&this.site.typeInventory==='weekly'){
          let days=inventory_data[1].split(',').map(el=>Number(el))
          let daysOfWeek= days.map(el=>this.list_day[el-1])
          this.tempInventoryReportSchedule='Weekly on every '+daysOfWeek.join(', ') +' at '+inventory_data[0] +' GMT+08:00'
          this.type_inventory='weekly'
          this.inventory_choose_week=days
        }
        // else if(this.site.typeInventory&&this.site.typeInventory==='monthly'){
        //   let days = inventory_data[1].split(',').map(el=>Number(el))
        //   this.tempInventoryReportSchedule='Monthly on every '+days.join(', ')+' at '+inventory_data[0] +' GMT+07:00'
        //   this.type_inventory='monthly'
        //   this.inventory_choose_month=days
        // }
        
      }
      if(this.site.overdueReportSchedule&&this.site.overdueReportSchedule!==''){
        let overdue_data = this.site.overdueReportSchedule.split(';')
        this.time_overdue=overdue_data[0]
        if(this.site.typeOverdue&&this.site.typeOverdue==='weekly'){
          let days=overdue_data[1].split(',').map(el=>Number(el))
          let daysOfWeek= days.map(el=>this.list_day[el-1])
          this.tempOverDueSchedule='Weekly on every '+daysOfWeek.join(', ') +' at '+overdue_data[0] +' GMT+07:00'
          this.type_overdue='weekly'
          this.overdue_choose_week=days
        }
        // else if(this.site.typeOverdue&&this.site.typeOverdue==='monthly'){
        //   let days = overdue_data[1].split(',').map(el=>Number(el))
        //   this.tempOverDueSchedule='Monthly on every '+days.join(', ')+' at '+overdue_data[0] +' GMT+07:00'
        //   this.type_overdue='monthly'
        //   this.overdue_choose_month=days
        // }
      }
    },
    validateEmail(el){
      return String(el)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    convertTime(time)
    {
        let dt = new Date(time)
        return `${
            (dt.getFullYear()).toString().padStart(4, '0')}-${
            (dt.getMonth()+1).toString().padStart(2, '0')}-${
            dt.getDate().toString().padStart(2, '0')} ${
            dt.getHours().toString().padStart(2, '0')}:${
            dt.getMinutes().toString().padStart(2, '0')}:${
            dt.getSeconds().toString().padStart(2, '0')}`
    },
    onAddEmail(){
      console.log('add email!')
      if(!this.validateEmail(this.email)){
        return alert('Please fill a valid email!')
      }
      let index= this.list_email.findIndex(el=>el.email===this.email)
      if(index>=0){
        return alert('This email existed!')
      }
      this.list_email.push({
        email:this.email,
        created:new Date().getTime()
      })
      this.email=''
    },
    onDeleteEmail(item){
      let index= this.list_email.findIndex(el=>el.email===item.email)
      if(index>=0){
        this.list_email.splice(index,1)
      }
    },
    sendMailNow(){
      // if(!this.site.email||this.site.email.length===0){
      //   return alert('Please add a receiver’s email!')
      // }
      this.send_active=true
      request('post', '/sites/send-mail', {_id:this.site._id})
      .then(()=>{
        console.log('send email done!')
        this.send_active=false
      })
      .catch(err=>{
        console.log('error send email:',err)
        
        this.send_active=false
        alert("Error send overdue report via email!")
      })
    },
    sendMusteringMailNow(){
      if(!this.site.email||this.site.email.length===0){
        return alert('Please add a receiver’s email!')
      }
      this.send_active=true
      request('post', '/sites/send-muster-mail', {email:this.site.email,_id:this.site._id})
      .then(()=>{
        console.log('send email done!')
        this.send_active=false
      })
      .catch(err=>{
        console.log('error send email:',err)
        
        this.send_active=false
        alert("Error send overdue report via email!")
      })
    },

    enableEditGeneralInfo() {
      this.generalInfoEditing = true
      this.tempSiteName = this.site.name
      this.tempPsmExpire = this.site.psmExpire
      this.tempSiteApiKey = this.site.apiKey
      this.tempSiteMode = this.site.mode
      this.tempActiveR = this.site.activeR
    },
    saveGeneralInfo() {
      if(!this.tempSiteApiKey || this.tempSiteApiKey.length<5){
        alert('Site Api Key is required and at least 8 characters.')
        return
      }
      if (!this.tempSiteName || !this.tempPsmExpire || !this.tempSiteApiKey) {
        alert('Site name is required.')
      } else {
        let data={
          _id:this.site._id,
          typeInventory:this.type_inventory,
          typeOverdue:this.type_overdue,
          name:this.tempSiteName,
          apiKey:this.tempSiteApiKey,
          mode:parseInt(this.tempSiteMode),
          activeR:parseInt(this.tempActiveR),
          email:this.list_email,
          psmExpire:this.tempPsmExpire,
          // reminderTime:this.reminder_time,
          inventoryReportSchedule:'',
          overdueReportSchedule:''
        }

        if(this.type_inventory==='weekly'){
          if(this.time_inventory===''){
            return alert('Please choose time for inventory stock report!')
          }
          if(this.inventory_choose_week.length===0){
            return alert('Please choose day  for inventory stock report!')
          }
          this.inventory_choose_week=this.inventory_choose_week.sort((a,b)=>a-b)
          data.inventoryReportSchedule=this.time_inventory+';'+this.inventory_choose_week.join(',')
          let days = this.inventory_choose_week.map(el=>{
            return this.list_day[el-1]
          })
          this.tempInventoryReportSchedule='Weekly on every '+days.join(', ')+' at '+this.time_inventory+' GMT+08:00'
        }
        // else if(this.type_inventory==='monthly'){
        //   if(this.time_inventory===''){
        //     return alert('Please choose time for inventory stock report!')
        //   }
        //   if(this.inventory_choose_month.length===0){
        //     return alert('Please choose day  for inventory stock report!')
        //   }
        //   this.inventory_choose_month=this.inventory_choose_month.sort((a,b)=>a-b)
        //   data.inventoryReportSchedule=this.time_inventory+';'+this.inventory_choose_month.join(',')
        //   this.tempInventoryReportSchedule='Monthly on every '+this.inventory_choose_month.join(', ') + ' at '+this.time_inventory+' GMT+08:00'
          
        // }

        // if(this.type_overdue===''){
        //   this.tempOverDueSchedule=''
        // }
        if(this.type_overdue==='weekly'){
          if(this.time_overdue===''){
            return alert('Please choose time for overdue  report!')
          }
          if(this.overdue_choose_week.length===0){
            return alert('Please choose day  for overdue stock report!')
          }
          this.overdue_choose_week=this.overdue_choose_week.sort((a,b)=>(a-b))
          let days = this.overdue_choose_week.map(el=>{
            return this.list_day[el-1]
          })
          data.overdueReportSchedule=this.time_overdue+';'+this.overdue_choose_week.join(',')
          this.tempOverDueSchedule='Weekly on every '+days.join(', ')+' at '+this.time_overdue+' GMT+08:00'
        }
        // else if(this.type_overdue==='monthly'){
        //   if(this.time_overdue===''){
        //     return alert('Please choose time for overdue report!')
        //   }
        //   if(this.overdue_choose_month.length===0){
        //     return alert('Please choose day  for overdue report!')
        //   }
        //   this.overdue_choose_month=this.overdue_choose_month.sort((a,b)=>(a-b))
        //   data.overdueReportSchedule=this.time_overdue+';'+this.overdue_choose_month.join(',')
        //   this.tempOverDueSchedule='Monthly on every '+this.overdue_choose_month.join(', ') + ' at '+this.time_overdue+' GMT+08:00'
          
        // }
        // console.log('data of setting site:',data)
        // this.generalInfoEditing=false
        // this.showSnackbar=true
        


        
        request('put', '/sites/info', data)
          .then(data => {
            this.site.name=data.site.name
            this.site.email =data.site.email
            this.site.psmExpire = data.site.psmExpire
            this.site.apiKey = data.site.apiKey
            this.site.mode = data.site.mode

            this.site.activeR = data.site.activeR
            // this.site.typeInventory=data.site.typeInventory
            // this.site.typeOverdue=data.site.typeOverdue
            this.site.overdueReportSchedule=data.site.overdueReportSchedule
            this.site.inventoryReportSchedule=data.site.inventoryReportSchedules
            // this.site.reminderTime = data.site.reminderTime
            // this.$store.commit("changeReminderTime", data.site.reminderTime);
            // this.site.lowStockSms = data.site.lowStockSms
            // this.site.lowStockEmail = data.site.lowStockEmail
            // this.site.lowStockSchedule = data.site.lowStockSchedule
            // this.site.inventoryReportSchedule = data.site.inventoryReportSchedule
            
            this.generalInfoEditing = false
            this.showSnackbar = true
          })
          .catch(err => console.log(err))
      }

    }
  }
}
</script>

<style lang="scss" >
.site-setting {
  // padding: 32px;
  
  margin-top:26px;
  .User__btn_container {
    text-align: right;
    margin-bottom: 20px;
    position: relative;
    z-index: 0;
    width: 100%;
    .Setting_btn {
      cursor: pointer;
      border-radius: 4px;
      font-size: 1rem;
      height: 48px !important;
      margin-right: 0px;
      border-radius: 4px;
      margin-left: 16px;
      .md-button-content{
          display: flex;
        justify-content: center;
        align-items: center;
        text-transform: none;
      }
    }

   
  }

  .general-info {
    background-color: #fff;
    padding: 32px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    .title {
      font-size: 20px;
      margin: 0;
    }

    .info-fields {
      display: flex;
      flex-wrap: wrap;
      // display: grid;
      // grid-template-columns: auto auto auto ;
      // grid-auto-flow:row;
      // direction: rtl;
      // gap: 8px 8px;
      .info-field {
        flex-basis: 33.33%;
        // width: 33.33%;
        margin-top: 24px;

        label {
          color: #6D6E71;
          font-size: 14px;
        }

        p {
          font-size: 16px;
          margin: 0;
          margin-top: 9px;
        }

        input,select {
          display: block;
          font-size: 16px;
          padding: 4px 8px;
          margin-top: 12px;
          width: calc(100% - 32px);
        }
      }
    }
  }

  .inventory-info {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    
    .low-stock {
      flex-basis: calc(50% - 16px);
      background-color: #fff;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
      padding: 32px;

      .title {
        font-size: 20px;
        margin: 0;
      }

      .info-fields {
        .info-field {
          flex-basis: 33.33%;
          // margin-top: 18px;

          label {
            color: #6D6E71;
            font-size: 14px;
          }

          p {
            font-size: 16px;
          }
        }
      }
    }

    .inventory-report {
      flex-basis: calc(50% - 16px);
      background-color: #fff;
      padding: 32px;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
      .title {
        font-size: 20px;
        margin: 0;
      }

      .info-fields {
        .info-field {
          margin-top: 16px;

          label {
            color: #6D6E71;
            font-size: 14px;
          }

          p {
            font-size: 16px;
          }
        }


      }
    }
  }
}
.mail-now {
          button {
            background-color: #4CAF50;
            color: #fff;
            font-size: 14px;
            padding: 8px 16px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            /deep/ .md-icon {
              color: #fff;
            }
          }
          button:hover{
            background-color: #85e588;
          }
        }
.Setting_btn{
  background-color: #0080F7;
  border-radius: 4px;
  text-transform: none; 
  font-size: 1rem;
  height: 48px !important;
  
  margin-bottom: 26px;
  margin-right: 0px;
  border-radius: 4px;
  width: 171px;
    .md-button-content{
      display: flex;
      justify-content: center;
      align-items: center;
  }
}
.checkbox-type{
  display: flex;
  flex-direction:flex-start;
}
.time-nofi-radios{
  margin-top:5px;
  display: flex;
  flex-direction: column;
  color: #171A26;
  input{
    cursor: inherit;
  }
  input[type="checkbox"]{
    transform: scale(1.5);
  }
  label{
    margin-bottom: 0px;
    color:#171A26 !important;
    cursor:inherit;
  }
  input[type="time"]{
    height: 48px;
    width: 160px;
    outline: none;
    border:none;
    background-color: #F3F3F3;
    // margin-top:16px;
    padding:0px 8px 0px 8px;
  }
  // input[type="time"]:focus{
  //   border: 1px solid #0080F6;
  // }
  input[type="time"]:hover{
    border: 1px solid #0080F6;
  }
  .item_container{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    background-color: #F3F3F3;
    padding: 16px;
    padding-bottom: 0px;
    .item_select{
      display:flex;
      flex-direction:column;
      align-items:center;
      justify-content: center;
      cursor: pointer;
      // padding: 8px;
      margin-bottom:16px;
      margin-right:16px;
    }
    
  }
}
.table_email_container{
  background-color: #fff;
  padding: 32px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  margin-top:24px;
  label{
    color: #6D6E71;
    margin-top:16px;
  }
  svg{
    cursor: pointer;
  }
  svg:hover path{
    fill: #ED1D24;
  }
  .form_container{
    display: flex;
    margin-bottom: 24px;
  }
  input,button{
    outline: none;
    border: none;
    height: 48px;
    border-radius: 4px;
    background-color: #F3F3F3;
  }
  input{
    
    padding: 0px 8px 0px 8px;
    width: 100%;
  }
  input:hover{
    border: 1px solid #0080F6;
  }
  button{
    width: 160px;
    margin-left: 24px;
    color: #0080F6;
    font-weight: bold;
    border: 2px solid #0080F6;

  }
  button:hover{
    background-color: #CFECF9;
    cursor: pointer;
  }
  
}
 .setting_title{
  font-size: 18px;
  font-weight: bold;
 }

</style>